import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  DocksData, GenericApiErrors, CreateNewDockParams, SetDockIsFreshData, SetDockIsExpressData,
  DockData,
  SetDockIsFreshPayload,
} from './DockManagementTypes'
import { badgeHeader } from 'src/services/Helper'

const getAllDocks = async (fc_id?: number) => {
  try {
    const params = fc_id ? { fc_id } : {}
    const result = await http.get('/v2/dock/', { params })
    return parseGoodResponse<DocksData[]>(result.data.docks)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const setDockFree = async (id_dock: number) => {
  try {
    const result = await http.patch(`/v2/dock/${id_dock}/change-status`)
    return parseGoodResponse<DocksData>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const createNewDock = async (payload: CreateNewDockParams) => {
  try {
    const {
      dockCode, groceryLocation, freshLocation, fresh, fulfillmentCenterId, express,
    } = payload
    const result = await http.post('/v2/dock/create', {
      dock_code: dockCode,
      grocery_location: groceryLocation,
      fresh_location: freshLocation,
      is_fresh: fresh,
      fulfillment_center_id: fulfillmentCenterId,
      is_express: express,
    })
    return parseGoodResponse<DocksData>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const setDockIsFresh = async (payload: SetDockIsFreshPayload) => {
  try {
    const { id, isFresh, badge } = payload

    const body = {
      id_dock: id,
      is_fresh: isFresh,
    }

    const result = await http.patch('/v2/dock/is-fresh', body, badge ? { headers: badgeHeader(badge) } : {})

    return parseGoodResponse<SetDockIsFreshData>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const setDockIsExpress = async (payload: SetDockIsExpressData) => {
  try {
    const { id, isExpress } = payload

    const result = await http.patch('/v2/dock/is-express', {
      id_dock: id,
      is_express: isExpress,
    })

    return parseGoodResponse<SetDockIsExpressData>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getDock = async (id: number) => {
  try {
    const result = await http.get(`/v2/dock/${id}`)
    return parseGoodResponse<DockData>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getAllDocks,
  setDockFree,
  createNewDock,
  setDockIsFresh,
  setDockIsExpress,
  getDock,
}
